import React from "react";
import TenantInfo from "./components/tenantInfo";
import FollowUpText from "./components/followUpText";
import VerifyTenantStatus from "./components/verifyTenantStatus";
import MarkTenantAsEvict from "./components/markTenantAsEvict";
import ContactTenant from "./components/contactTenant";
import PaymentRecieved from "./components/paymentReceived";
import FileForEviction from "./components/fileForEviction";
import MoveOutChecklist from "./components/moveOutChecklist";
import HouseVacant from "./components/houseVacant";
import HearingLost from "./components/hearingLost";
import AwaitingLockout from "./components/awaitingLockout";
import LockoutNotComplete from "./components/lockoutNotComplete";
import Eviction from "./components/eviction";
import ItemsLeftAtHome from "./components/itemsLeftAtHome";
import EndingManagment from "./components/endingManagment";
import CancelEvictionProcess from "./components/cancelEvictionProcess";

const PayOrQuit = ({ itemId, listId, checkedItems }) => {
  return (
    <div>
      {itemId === 1 && (
        <TenantInfo
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 2 && (
        <FollowUpText
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 3 && (
        <VerifyTenantStatus
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 4 && (
        <MarkTenantAsEvict
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 5 && (
        <ContactTenant
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 6 && (
        <PaymentRecieved
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 7 && (
        <FileForEviction
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 8 && (
        <MoveOutChecklist
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 9 && (
        <HouseVacant
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 10 && (
        <HearingLost
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 11 && (
        <AwaitingLockout
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 12 && (
        <LockoutNotComplete
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 13 && (
        <Eviction itemId={itemId} listId={listId} checkedItems={checkedItems} />
      )}
      {itemId === 14 && (
        <ItemsLeftAtHome
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 15 && (
        <EndingManagment
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 16 && (
        <CancelEvictionProcess
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
    </div>
  );
};

export default PayOrQuit;
